<script setup lang="ts">
import { computed, ref } from 'vue'
import { useNavStore } from '@/stores/nav.store'
import { useIdeStore } from '@/stores/ide.store'
import LogoWhite from '@/assets/images/JD_logo_white.png'
import LogoBlack from '@/assets/images/JD_logo_colour.webp'
import LogoSmall from '@/assets/images/ide/LogoSmall.svg'
import LogoBg from '@/assets/images/ide/LogoBg.svg'

const ideStore = useIdeStore()
const navStore = useNavStore()
const colorTheme = ref<string>('light')

const props = defineProps({
  isLink: {
    type: Boolean,
    required: false,
    default: true
  },
  isLoginModal: {
    type: Boolean,
    required: false,
    default: false
  },
  blackLogo: {
    type: Boolean,
    required: false,
    default: false
  }
})

const isIdeView = computed(() => {
  return ideStore.isIdeView || !navStore.isMarketingPage
})

const isDefaultLightMode = computed(() => {
  if (!props.isLoginModal) {
    if (colorTheme.value == 'dark' || ideStore?.colorMode == 'dark') return true
    return false
  }
  return false
})
</script>

<template>
  <div
    v-if="props.isLink"
    :class="
      isIdeView && !blackLogo
        ? 'w-[40px] sm:flex sm:items-center sm:justify-center'
        : 'w-auto sm:-ml-5'
    "
  >
    <RouterLink :to="{ name: 'home' }" class="link-primary">
      <!-- Fullsize Logos -->
      <img
        v-if="!isIdeView && isDefaultLightMode"
        class="w-[130px] md:w-[200px] print:hidden"
        :src="LogoWhite"
        alt="JDoodle"
      />
      <img
        v-if="!isIdeView && !isDefaultLightMode"
        class="w-[130px] md:w-[200px] print:hidden"
        :src="LogoBlack"
        alt="JDoodle"
      />

      <!-- Small Logo (ide only) -->

      <div v-if="isIdeView && !blackLogo" class="flex h-10 w-10 items-center justify-center">
        <div class="relative">
          <img class="rounded-full" :src="LogoBg" />
        </div>
        <div class="absolute">
          <img :src="LogoSmall" />
        </div>
      </div>

      <!-- Black Logo  -->
      <img
        v-if="isIdeView && blackLogo"
        class="w-[130px] md:w-[200px] print:hidden"
        :src="LogoBlack"
        alt="JDoodle"
      />

      <!-- TODO: Check print sizing for IDE -->
      <img class="hidden w-[130px] sm:w-[200px] print:block" :src="LogoBlack" alt="JDoodle" />
    </RouterLink>
  </div>
  <div v-else class="link-primary -ml-4">
    <img
      v-if="isDefaultLightMode"
      class="w-[200px] sm:w-[230px] print:hidden"
      :src="LogoWhite"
      alt="JDoodle"
    />
    <img v-else class="w-[200px] sm:w-[230px] print:hidden" :src="LogoBlack" alt="JDoodle" />
    <img class="hidden w-[200px] sm:w-[230px] print:block" :src="LogoBlack" alt="JDoodle" />
  </div>
</template>
